module.exports = __webpack_public_path__ + "bitbucket-logo.png";